import React from 'react';
import './Hero.scss';
import sponsors from '../../_assets/_img/sponsors.png';
import videoFile from '../../_assets/videos/CP512_AVT_LoopingBG_3.mp4';

const Hero = () => {
  return (
    <div className="hero">
      <video autoPlay playsInline loop muted src={videoFile}></video>
      <div className="gradient"></div>
      <div className="hero-inner">
        <div className="sponsor-container">
          <img src={sponsors} className="sponsor-image"/>
        </div>

        <div className="headliner">
          <p className="main-title">The Game Plan</p>
          <p className="">Building A Strong Financial Future</p>
        </div>
        
        <p className="first-p">2020 may be behind us, but for many, the journey back to financial health is just beginning.</p>
      </div>
    </div>
  )
}
export default Hero;